import { render, staticRenderFns } from "./orderQueryDetail.vue?vue&type=template&id=65cc1bfa&"
import script from "./orderQueryDetail.vue?vue&type=script&lang=js&"
export * from "./orderQueryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports